import { FileCheck } from 'lucide-react';
import * as React from 'react';

import type { DiscriminatedMatterRetainerSignedByAttorneyEvent } from '@/services/api/generated/taskActivityService';

import { EventBody, EventContainer, EventHeader } from './EventPrimitives';

interface MatterRetainerSignedByAttorneyEventProps {
  event: DiscriminatedMatterRetainerSignedByAttorneyEvent;
  matterId: string;
}

export const MatterRetainerSignedByAttorneyEvent: React.FC<
  MatterRetainerSignedByAttorneyEventProps
> = ({ event, matterId }) => {
  const { payload, occurred_at, user, agent } = event;
  const { matter } = payload;

  return (
    <EventContainer>
      <EventHeader
        icon={<FileCheck size={20} />}
        title="Retainer Signed by Attorney"
        timestamp={occurred_at}
        actor={user}
        agent={agent}
      />

      <EventBody>
        <div className="text-xs text-slate-700">
          The attorney signed the retainer agreement for{' '}
          <span className="font-medium">{matter.name}</span>.
        </div>
      </EventBody>
    </EventContainer>
  );
};
